import * as React from "react";
const SvgCellCloseFilled = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#cellCloseFilled_svg__a)" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.999 12v11.002h22.003V.997H.999V12Zm6 0v1.248h10.003v-2.496H6.999V12Z", fill: "currentColor" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "cellCloseFilled_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" })))));
export default SvgCellCloseFilled;
